import { Controller } from "@hotwired/stimulus"
import TomSelect from "tom-select"

export default class extends Controller {
  static values = {
    options: Object,
    placeholder: String,
    maxItems: Number
  }

  connect() {
    const elementId = this.element.id
    console.log(`tom-select connecting on #${elementId}`)

    const maxItems = this.maxItemsValue || 1

    // Only use plugins for multi-select (maxItems > 1)
    const plugins = maxItems > 1 ? ['remove_button', 'clear_button'] : ['clear_button']

    const defaultOptions = {
      plugins: plugins,
      persist: false,
      create: false,
      placeholder: this.placeholderValue || 'Sélectionnez...',
      maxItems: maxItems,
      dropdownParent: 'body', // Important: affiche le dropdown au-dessus de tout
      render: {
        no_results: function(data, escape) {
          return '<div class="no-results">Aucun résultat trouvé pour "' + escape(data.input) + '"</div>';
        }
      }
    }

    const options = { ...defaultOptions, ...this.optionsValue }

    this.tomSelect = new TomSelect(this.element, options)

    // ✅ CRITICAL: Assign to element.tomselect BEFORE dispatching event
    // This ensures team_form_controller can access it via joueur1SelectTarget.tomselect
    this.element.tomselect = this.tomSelect

    console.log(`tom-select connected on #${elementId}, maxItems: ${maxItems}`)

    // Listen to TomSelect's native 'change' event
    this.tomSelect.on('change', () => {
      // Trigger native change event on the select element
      this.element.dispatchEvent(new Event('change', { bubbles: true }))
    })

    // Dispatch custom event to notify that TomSelect is ready
    this.element.dispatchEvent(new CustomEvent('tomselect:ready', {
      bubbles: true,
      detail: { tomselect: this.tomSelect }
    }))
  }

  disconnect() {
    const elementId = this.element.id
    console.log(`tom-select disconnecting from #${elementId}`)
    if (this.tomSelect) {
      this.tomSelect.destroy()
      this.tomSelect = null
    }
    // Clean up the reference on the element
    if (this.element.tomselect) {
      this.element.tomselect = null
    }
  }
}
